export enum ResourceType {
  Room = 'room',
  Desk = 'desk',
}
